/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvSkeletonSignature {
  Args: {
    delay?: `${number}ms`;
    variation?: 'sm' | 'xs' | 'tab';
    width?: number;
  };
  Element: HTMLDivElement;
}

const BvSkeletonComponent = templateOnlyComponent<BvSkeletonSignature>();

export default BvSkeletonComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvSkeleton: typeof BvSkeletonComponent;
    'bv-skeleton': typeof BvSkeletonComponent;
  }
}
